{
  "version": 1,
  "asset_id": "521895fa-43e9-41a1-9c3b-285e69b328ad",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/521895fa-43e9-41a1-9c3b-285e69b328ad/bypass-revision-weight-chart.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/521895fa-43e9-41a1-9c3b-285e69b328ad/bypass-revision-weight-chart.png",
  "original_filename": "bypass-revision-weight-chart.png",
  "size": 100411,
  "content_type": "image/png",
  "created_at": "2026-11-01T23:24:12Z"
}
